import { EpicStatus } from "@/models"
import { Filter } from "@/models/Pageable"

export class FilterEpic extends Filter {
  q = ""
  inMilestone?: boolean
  inTeam?: boolean
  teamIds: string[] = []
  archived?: boolean
  label = ""
  status?: EpicStatus
  featureId = ""
  inFeature?: boolean
  tshirtSize?: boolean
  projectId = ""
  projectName = ""
  projectIds: string[] = []

  constructor(props?: Partial<FilterEpic>) {
    super(props as Filter)
    if (!props) return
    Object.keys(props).forEach(field => {
      this[field] = props[field]
    })
  }

  getJsonObj() {
    const data = {
      q: this.q,
      inMilestone: this.inMilestone,
      inTeam: this.inTeam,
      teamIds: this.teamIds,
      archived: this.archived,
      label: this.label,
      status: this.status,
      featureId: this.featureId,
      inFeature: this.inFeature,
      tshirtSize: this.tshirtSize,
      projectIds: this.projectIds
    }
    return super.getJsonObj({ params: data })
  }

  static create(props) {
    return new FilterEpic(props)
  }

  static createDefault() {
    const props = {}

    return new FilterEpic(props)
  }
}
